const ID_SEGMENT = /^([0-9A-Za-z]{11}|[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const ALLOWED_SCHEMES = new Set(['http:', 'https:']);

/** Path only — no query (search terms, invite codes), no fragment; opaque id segments templated.
 *  A non-http(s) absolute URL (mailto:, tel:, data:, ...) carries its opaque payload — an email
 *  address, a phone number, inline file content — as what `URL.pathname` reports; collapse those
 *  to '{ext}' instead of templating (and thereby exposing) that payload. */
export function templatePath(url: string): string {
  try {
    const scheme = new URL(url).protocol; // succeeds only for an ABSOLUTE url — i.e. one with a scheme
    if (!ALLOWED_SCHEMES.has(scheme)) return '{ext}';
  } catch {
    // relative — no scheme, falls through to path templating below
  }

  let path: string;
  try {
    path = new URL(url, 'https://local').pathname;
  } catch {
    path = url.split(/[?#]/)[0];
  }
  return path
    .split('/')
    .map((seg) => (ID_SEGMENT.test(seg) ? '{id}' : seg))
    .join('/');
}
